// extracted by mini-css-extract-plugin
export default {"link":"dL-z","disabled":"eL-z"};